import common from '../language/en/common.json';
import login from '../language/en/login.json';
import search from '../language/en/search.json';

import button from '../language/en/button.json';
import home from '../language/en/home.json';
import menu from '../language/en/menu.json';
import share from '../language/en/share.json';
import user from '../language/en/user.json';
import master from '../language/en/master.json';
import systemInfo from './en/systemInfo.json';
import tracker from './en/tracker.json';
import settings from './en/settings.json';
import training from './en/training.json';
import settingsCarReservation from './en/settingsCarReservation.json';
import car from './en/car.json';
import driverJob from './en/driverJob.json';
import project from './en/project.json';

export default {
    ...common,
    ...login,
    ...search,
    ...button,
    ...home,
    ...menu,
    ...share,
    ...user,
    ...master,
    ...systemInfo,
    ...tracker,
    ...settings,
    ...training,
    ...settingsCarReservation,
    ...car,
    ...driverJob,
    ...project
};



// WEBPACK FOOTER //
// ./src/wording/language/en.js